import { render, staticRenderFns } from "./SMSVerificationDialog.vue?vue&type=template&id=f0f76e62&scoped=true"
import script from "./SMSVerificationDialog.vue?vue&type=script&lang=js"
export * from "./SMSVerificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f76e62",
  null
  
)

export default component.exports